// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"build_node_index_js":"f5c8c75616ec0ee284f40094e514837e53f58cb849e86cb1c04edf718c50e580","node_modules_react_index_js":"322dd505b94fc6c6f0343105da33504882dbd4ab7cf2f3e05c42087c11591e18"}[chunkId] + ".js";
};